import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/icons/Logo';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <Link to="/">
            <Logo className="h-16 mx-auto" showCompanyName={false} />
          </Link>
          <h1 className="mt-6 text-3xl font-extrabold text-gray-900">Privacy Policy</h1>
        </div>
        
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6 prose max-w-none">
            <h2>1. Introduction</h2>
            <p>
              Energia Info Kft. is committed to protecting your privacy. This Privacy Policy explains how we collect,
              use, and safeguard your information when you use our YouCRM system.
            </p>
            
            <h2>2. Information We Collect</h2>
            <p>
              We collect information that you provide directly to us, including personal information such as your name,
              email address, and other contact details. We also collect information about your customers, suppliers,
              and business partners that you enter into the system.
            </p>

            <h2>3. How We Use Your Information</h2>
            <p>
              We use the information we collect to provide, maintain, and improve our services, to develop new features,
              and to protect our users. The system contains sensitive business information that is only accessible by
              authorized personnel.
            </p>

            <h2>4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your information from unauthorized access, alteration,
              disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.
            </p>

            <h2>5. Data Retention</h2>
            <p>
              We retain your information for as long as your account is active or as needed to provide you services.
              We will retain and use your information as necessary to comply with our legal obligations, resolve disputes,
              and enforce our agreements.
            </p>

            <h2>6. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new
              Privacy Policy on this page and updating the effective date.
            </p>

            <div className="mt-8 text-center">
              <Link to="/login" className="text-primary-600 hover:text-primary-700">
                Return to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 